/*
 * Central teardown for everything the app persists in the browser.
 *
 * Logout used to remove a hand-picked list of sessionStorage keys, so anything
 * added later (currency settings, cached invoice history, the whole restaurant
 * floor state in localStorage) survived into the next session - and into the
 * next user's session on a shared POS terminal.
 */

import { RESTAURANT_STORAGE_KEY } from "../Store/Slices/restaurantSlice";
import { DELIVERY_ORDERS_STORAGE_KEY } from "../Store/Slices/deliveryOrdersSlice";

// Business data persisted in localStorage. These belong to the signed-in
// session and must not leak across logins.
export const PERSISTED_DATA_KEYS = [
  RESTAURANT_STORAGE_KEY,
  DELIVERY_ORDERS_STORAGE_KEY,
  "posInvoiceHistory",
];

// Device/UI preferences that intentionally outlive a session.
const PRESERVED_LOCAL_KEYS = [
  "pos-theme",
  "pos:kitchen-stations",
  "pos:server-stations",
];

export const isPreservedLocalKey = (key) =>
  PRESERVED_LOCAL_KEYS.includes(key) || key.startsWith("pos:workspace:");

/**
 * Wipe every trace of the current session.
 *
 * sessionStorage is cleared wholesale rather than key-by-key so no future key
 * can be forgotten here. localStorage is pruned selectively because it also
 * holds device preferences (theme, station selection, workspace layout).
 */
export const clearBrowserSession = () => {
  if (typeof window === "undefined") {
    return;
  }

  try {
    window.sessionStorage.clear();
  } catch {
    // ignore storage errors (private mode / disabled storage)
  }

  try {
    PERSISTED_DATA_KEYS.forEach((key) => window.localStorage.removeItem(key));
  } catch {
    // ignore storage errors
  }
};
